import { styled } from '@mui/system'
import { Button, Tooltip } from '@mui/material'
import { lighten } from '@mui/material/styles'
import colors, { STATE_LAYER_OPACITY } from 'common/colors'

export function ExpandableToolbarButton(props) {
  return (
    <Tooltip title={props.label} placement="right" disableInteractive>
      <StyledContainer expanded={props.expanded} $active={props.$active}>
        <StyledButton
          expanded={props.expanded}
          $active={props.$active}
          disabled={props.disabled}
          onClick={props.onClick}
          startIcon={props.icon}
        >
          <span className="label">{props.label}</span>
        </StyledButton>
      </StyledContainer>
    </Tooltip>
  )
}

// Prevent $active from being forwarded to the DOM
const StyledContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== '$active',
})((props) => ({
  backgroundColor: colors.greyHover,
  width: props.expanded || props.$active ? '100%' : '32px',
  ...(!props.expanded &&
    props.$active && {
      '&&&': {
        borderTopRightRadius: '4px',
        borderBottomRightRadius: '4px',
      },
    }),
}))

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== '$active',
})((props) => ({
  minWidth: 0,
  height: '32px',
  justifyContent: 'start',
  fontSize: '12px',
  fontWeight: 500,
  color: colors.greyText,
  width: props.expanded ? '100%' : 'fit-content',
  '& .MuiButton-startIcon': {
    marginLeft: '-2px',
  },
  '& svg path': {
    color: colors.greyText,
  },
  '& span.label': {
    display: props.expanded || props.$active ? 'inline' : 'none',
    whiteSpace: 'nowrap',
  },
  ...(props.$active && {
    position: 'relative',
    width: 'fit-content',
    backgroundColor: colors.brand,
    color: colors.white,
    '&:hover': {
      backgroundColor: lighten(colors.brand, STATE_LAYER_OPACITY.hover),
      color: colors.white,
    },
    '& svg path': {
      stroke: colors.white,
      fill: 'none',
    },
  }),
  ...(props.disabled && {
    '& svg': {
      opacity: 0.26,
    },
  }),
}))
